export const en = {
  Login: 'Login',
  success: 'Successfully done!',
  NovalidEmailPass: 'Invalid email or password',
  Next: 'Next',
  Day: 'DD',
  Month: 'MM',
  Year: 'YYYY',
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
  Accept: 'I accept',
  Agree: 'I agree',
  Nagree: 'I do not agree',
  Yes: 'Yes',
  No: 'No',
  NoThanks: 'No, Thanks.',
  Ihave: 'Activate a MyPass Sci card',
  Idonthave: 'I do not have a MyPass Sci card',
  Allareas: 'MyPass ski resorts',
  Withdraw: 'Collect at the ski resort',
  Ship: 'Ship to home',
  Male: 'M',
  Female: 'F',
  Parent: 'I accept as a parent or legal guardian',
  Apply: 'Apply',
  Resend: 'Resend Email',
  ResendSMS: 'Resend SMS',
  Wrong: 'Inserted wrong email?',
  WrongPhone: 'Inserted wrong phone number?',
  Tab1: 'Skiers & Cards',
  Tab2: 'Movements',
  Tab3: 'Payment methods',
  Tab4: 'Privacy',
  Tab5: 'Support',
  Fullname: 'Name and Surname:',
  Born: 'Born on:',
  Status: 'Service status:',
  Renewal: 'Automatic renewal:',
  Activate: 'To be activate',
  Active: 'Active until',
  Expired: 'Expired on',
  Upload: 'Upload',
  Uploaddoc: 'Upload doc.',
  Cardactivate: 'CARD TO ACTIVATE',
  Insert: 'Insert the card number',
  Activatecard: 'Activate card',
  Adulto: 'Adult',
  Adult: 'Adult',
  Senior: 'Senior',
  Junior: 'Junior',
  Baby: 'Baby',
  Type: 'Type:',
  Blockcard: 'Block card',
  Replacecard: 'Request card replacement',
  Cardblocked: 'CARD BLOCKED',
  Unblockcard: 'Request assistance to unblock card',
  Cost: 'The card replacement costs €5',
  Requestpa: 'Request card',
  Requestnpa: 'Request card',
  Renew: 'Renew',
  Addnew: 'Add new skier',
  Contact: 'For information and assistance, contact us the way as you prefer:',
  Read: 'Read our',
  Nouser: 'You do not have any registered skier yet',
  NoMovement: 'There are no movements yet',
  Insertm: 'Insert',
  Nomethod: 'Insert payment method',
  Edit: 'Edit',
  Delete: 'Delete',
  Creditcards: 'Credit cards:',
  Debitcards: 'Debit cards:',
  Save: 'Save',
  Cancel: 'Cancel',
  Verify: 'Verify',
  ValidCouponFor: 'Valid coupon for',
  TotalToPay: 'Total to pay',
  Cradverify: 'After entering your credit card details, you would be charged and then will be refunded €0.10 for data verification.',
  Fullnameinput: 'Name and Surname',
  Cardnum: 'Card number',
  Nomethodinput: 'Credit Card data', // 'Insert payment method:',
  Initialcookiesprivacy: 'I consent to the processing of my data by MYPASS for the purposes of commercial information provided by MYPASS itself, also by sending newsletters and using profiling cookies (optional).',
  Initialdataprivacy: 'I consent to the transfer of my data by MYPASS to the partner company of MYPASS, for purposes of commercial information provided by said companies, also with the use of profiling cookies (optional).',
  Deletea: 'Delete account',
  Profile: 'Profile',
  Cellphone: 'Cellphone',
  Changep: 'Change password',
  Confirm: 'Confirm',
  Continue: 'Continue',
  Enterop: 'Enter the old password',
  Enternp: 'Enter the new password',
  Newmail: 'New e-mail',
  Yourmail: 'Your e-mail is',
  YourPhone: 'Your phone number is',
  Insertmail: 'Insert the new e-mail address.',
  Confirmail: 'Confirm e-mail',
  Insertcode: 'Insert the 5-digit code you received via e-mail.',
  InsertcodeSMS: 'Insert the 5-digit code you received via SMS.',
  Sureblock: 'Are you sure you want to block your card?',
  Byblock: 'You can only unlock it by contacting support',
  Seeall: 'Other payments',
  Retrypayment: 'Retry payments',
  Allmovements: 'All movements',
  Passyear: 'Year',
  Ok: 'OK',
  AlertRenew: "Are you sure you want to renew the service? %{price}€ will be charged on the registered payment card.",
  ErrorRenewService: "An error occurred while renewing the service.",
  DoYouHaveCoupon: "Do you have a coupon?",
  PaymentWentWrong: 'The payment could not be completed, the error message received is: ',
  Uploadocuments: 'Upload documents and photo to be considered as discounted rates',
  Attentionexpired: 'ATTENTION! ACCOUNT BLOCKED DUE TO EXPIRED PAYMENT CARD',
  Updatecard: 'UPDATE PAYMENT CARD',
  Attentionsuspended: 'ATTENTION! ACCOUNT BLOCKED DUE TO SUSPENDED PAYMENTS',
  Completepayment: 'Complete the payment if necessary by changing the credit card',
  Showsuspended: 'SHOW SUSPENDED PAYMENTS',
  Datamodified: ' ',
  Datamodified_msg: 'Your profile has been changed successfully!',
  Suredelete: 'Are you sure that you want to delete your account?',
  Alleliminate: 'All account data would be eliminated, so it will no longer be possible to recover them.',
  Emailsent: 'E-mail sent correctly!',
  Confirmrenew: 'Confirm the renewal of MyPass Sci service?',
  Charge: 'Are you sure you want to renew the service?',
  Attention: 'ATTENTION!',
  Atleast: 'To use the Sci services or request a card, the Account holder must be at least 16 years old.',
  Gotit: 'Ok, I got it',
  Surecancel: 'Are you sure that you want to cancel the registration?',
  Allost: 'All your inserted data will not be saved',
  Returnlogin: 'Return to login',
  Returnsite: 'Return to site',
  Alreadyreg: 'Skier already registered.',
  Ifuwant: 'If you want to add another card for this skier you can do it in the user area at the end of the registration.',
  Oops: 'OOPS! SOMETHING WENT WRONG!',
  Nosuccess: 'Your transaction has not been successful, try again. If the problem persists, contact support.',
  Retry: 'Try again',
  Goto: 'Go to the User Area',
  Wespeed: 'NO LINE GOOD TIME',
  Youforget: 'Did you forget your password?',
  Nothave: 'Do not have an account yet?',
  Signup: 'Sign up',
  Insertdata: 'Insert your data',
  Name: 'Name',
  Surname: 'Surname',
  Email: 'Email',
  Password: 'Password',
  Confirmpass: 'Confirm password',
  Birthday: 'Date of birth',
  Necessary: 'The date of birth is necessary to verify that the user is at least 16 years as for current legislation and to take advantage of any concessions and discounts',
  RemoveCard: 'Are you sure that you want to remove this card?',
  Err_maxNumberExeeds: 'The maximum number of cards cannot be more than 5!',
  Card: 'Card',
  CodFis: 'Fiscal Code',
  Number: 'N°:',
  Telnumber: '+39 011 19 116 039',
  Assisemail: 'assistenza@mypass.cc',
  Cvv: 'CVV Code',
  Confirmbymail: 'Confirm by Email',
  ConfirmPhone: 'Confirm phone number',
  Resendb: 'Resend',
  ResendCode: 'Resend code',
  Changee: 'Change Email',
  ChangePhoneNumber: 'Change phone number',
  Changeeua: 'Change e-mail',
  Insertynmail: 'Insert your new Email',
  InsertPhoneNumber: 'Insert your new phone number',
  PhoneNumber: "Phone number",
  ErrorSendingSMS: "There was an error sending the SMS. Please try again. If the problem persists, contact support.",
  Insertynmailua: 'Insert your new e-mail',
  Welcome: 'Welcome to the MyPass Sci world',
  Later: 'Register your cards later',
  Passrecovery: 'Password recovery',
  setPassword: 'Create password',
  Resetpass: 'Enter your e-mail in order to reset your password',
  setPassText: 'Enter your e-mail in order to create your password',
  Sendagain: 'Send me the identification code again',
  Passchanged: 'Password changed successfully!',
  Changeinfo: 'You can change your information later in the User Area.',
  Gotologin: 'Go to Login',
  PrivacyCheck1: 'By creating an account you agree to  ',
  PrivacyCheck2: 'of My Pass',
  And: 'and',
  PrivacyPolicy: 'Privacy Policy',
  Purchasedone: 'PURCHASE MADE SUCCESSFULLY!',
  Whenreceive: '',
  currency: '€',
  hour: 'H',
  Purchase: 'Purchase',
  Wheretoski: 'Where do you go to ski?',
  Shipadd: 'Shipping address',
  Bypriority: 'Cards will be sent to the provided address in',
  Fourdays: 'four working days',
  Wheretoreceive: 'Where do you want to receive the card?',
  Uploadrequested: 'Upload requested data',
  Identificationcard: 'Identification card',
  Identificationcard_nodoc: 'Identification document',
  AlreadyUploaded: 'Already uploaded',
  Drivinglicense: 'Driving license',
  Passport: 'Passport',
  Recphoto: 'Recognizable uncovered face photo of the card holder',
  Childiscount: 'I consent to the processing of personal data of my child, or minor of which I am tutor, by MYPASS, in order to benefit from the discounted rates provided.',
  Uploadfront: 'Upload the front',
  Uploadback: 'Upload the back',
  Uploadfirst: 'Upload the first internal page',
  At: 'At',
  Street: 'Street',
  Streetnum: 'Street Num.',
  City: 'City',
  Postalcode: 'Postal Code',
  Province: 'Province',
  Country: 'Country',
  Insertpayinfo: 'Insert payment information',
  SuccessfullPaymentTitle: 'PURCHASE MADE WITH SUCCESS!',
  SuccessfullPaymentMessage: 'Remember to activate the cards when you get hold of it.',
  Pay: 'Pay',
  Nameoncard: 'Name on the Card',
  Downloadapp: 'DOWNLOAD THE APP TO HAVE ACCESS TO YOUR USER AREA',
  Downloadnow: 'Discover all the new features present in the new application, download it now!',
  Conditions: 'Conditions of use',
  Terms: 'Terms of use',
  Andthe: 'and the ',
  Privacydisclaim: 'Privacy Disclaimer',
  Disclaimer: 'Disclaimer of',
  Privacy: 'Privacy',
  Mandatory: '(mandatory).',
  Accepti: 'I accept',
  Insertcardcode: 'Insert code of your card',
  Insertback: 'Insert the code that you can find on the back of your card',
  Codenum: 'Code number',
  Informskidata: 'Your card turns out to be Skidata. We would like to inform you that if you want to go to Andalo Paganella or Monte Bondone you must request the specific card later.',
  Informaxess: 'Your card turns out to be Axess. We would like to inform you that if you want to go to all the other MyPass associated resorts you must request the specific card later.',
  Setupcard: 'Setup your card',
  Ifnotedit: 'If you are not the card holder edit the data',
  InfoCannotBeEdited: 'The information can not be changed when you add the second card',
  Subscription: 'Annual subscription to MyPassSci,',
  Valid365: 'is valid 365 days after activation, including card shipping to home if required.',
  Needupload: 'You will need to upload an identity document and a photo.',
  Holder: 'Holder',
  State: 'State',
  Cardnumber: 'Card Num.',
  Inship: 'In shipping',
  Removecard: 'Remove card',
  Discountcode: 'Do you have any discount code?',
  Insertdiscount: 'Insert your discount code here',
  Purchasediscount: 'Purchase with discount code',
  Skipurchase: 'Skip and purchase',
  Total: 'TOTAL',
  Summary: 'Summary',
  Operationcompleted: 'Operation succesfully completed!',
  Logout: 'Logout',
  YouCannotBuyThisCard: 'You already have this card type!  Please try with the other',
  CartExsistMessage: 'It seems that you have already bought some cards. Do you want to continue the purchase or delete the cart?',
  TobeCollected: 'To be collected',
  CardExits: 'Attention, this skier already has a card of this type',
  Passleast: '(Password must be at least 8 characters)',
  AccountDeleted: 'ACCOUNT DELETED!',
  AccountDeleted_msg: 'Your account has been deleted successfully.',
  DocsUploaded: 'Your documents have been uploaded correctly and will be validated as soon as possible!',
  ProfilePhotoChanged: 'Your photo has been uploaded correctly',
  Finalprice: 'FINAL PRICE',
  EmailSentSuccessfully: 'Email successfully sent! Check your inbox',
  EmailChangedSuccessfully: 'Email successfully changed! Check your inbox',
  cantcloseEmailForm: 'The registration process will be interrupted. Are you sure you want to proceed?',
  removeCCTitle: 'Are you sure you want to remove your credit card?',
  removeCCNotice: 'Remember that you must have a valid credit card inserted in order to ski',
  Remember: 'Remember to upload your photo if you plan to ski more than 8 consecutive days',
  Deleteimage: 'Do you really want to delete this image and upload another one?',
  Exit: 'Exit',
  Close: 'Close',
  UpdateInfo: 'Update',
  WantToResend: "Are you sure you want to resend sms code",
  SMSSent: "Phone number verification SMS sent.",
  ResendIn: "You can resend code in ",
  Seconds: "seconds",
  ContactUs: "You have reached the maximum number of attempts to resend the SMS. Please contact us for support.",
  SMSFailedSending: "Failed sending number verification SMS.",
  CCNumberIsWrong: 'Credit card number is wrong',
  CCHolderNameIsWrong: 'Credit card holder name is wrong',
  CCCvvIsWrong: 'Credit card CVV is wrong',

  loginbyFB: 'Login with Facebook',
  loginbyGoogle: 'Login with Google',
  loginbyApple: 'Login with Apple',

  CCNumberLabel: 'Card number',
  cvvDescription: 'The 3-digit CVV code is located on the back of the card.',
  completeYourData: 'Completa i tuoi dati',
  completeYourData_2: 'Per poter usufruire del servizio di MyPass Ski, compila i campi richiesti.',

  standardPost: 'Standard delivery',
  withinFourDays: 'within four working days',
  shippingCost: 'Shipping cost',
  discount: 'Discount',
  cardValidateError: 'Invalid code, verify its correctness!',
  cardValidationSysError: 'System Error. If the problem persists contact support.',
  cardValidationProviderError: 'Problems contacting the provider of the service. Please try again later or contact support.',

  issueWithSella: 'il nostro partner bancario sta rilevando in queste ore alcune problematiche sui propri server. Per questo motivo il pagamento effettuato da computer desktop non andrà a buon fine. Ti invitiamo ad effettuare il pagamento dall\'app Mypass ski',
  moreInfo: 'More info',
  deletingTheSkier: 'Are you sure you want to delete this skier?',
  pagenotfound: 'Oops! The page you\'re looking for can\'t be found ...',
  timeoutMessage: 'We\'re sorry! We\'re facing some technical difficulties. It won\'t take long, please try again later. If the problem persists contact support.',
  reserveYourAccess: 'Reserve your access to resort',
  goToWallet: 'Your Reservations',
  proofOfAddress: 'Please select a valid document for proofing your residence address then press Upload',
  back: 'Back',
  InsertYourData: 'Insert your data',
  ConfigureYourKeycard: 'Configure your Keycard',
  PaymentDetails: 'Payment details',
  StartSkiing: 'Start skiing!',
  NumberCard: 'Card number',
  WhereDoYouGoSkiing: "Where do you go skiing?",
  LimitedResortsRequest: "Please select the ones you are interested in (up to a maximum of ",
  LimitedResortsNumber: "The inserted card is compatible only with certain ski resorts.",
  UploadSkierPhotoTitle: "Final step for card activation!",
  ActivateCard: "Activate",
  FailedVerifyingPhoneNumber: "Failed to verify if phone number is valid. Please contact support.",
}



// WEBPACK FOOTER //
// ./src/assets/locales/en.js